<template>
  <div class="processingRate-container">
    <div class="rangeContainer">
      <simple-select
        :options="rangeOptions"
        :autoSelect="false"
        :label-in-value="false"
        v-model="currentRange"
      ></simple-select>
    </div>

    <a-spin :spinning="loading">
      <div id="processing-rate-chart" style="height: 222px; text-align: center; line-height: 222px">
        <a-progress
          type="circle"
          status="normal"
          :percent="rate"
          :strokeWidth="8"
          :width="200"
          :strokeColor="getColor(rate)"
        />
        <div class="circle">{{ rate }}%</div>
      </div>

      <div style="text-align: center; margin-top: 2px">
      <a-space :size="24">
        <a-statistic
          :value="total"
          :valueStyle="{
            fontSize: '14px',
            lineHeight: '17px',
            textAlign: 'center',
            color: 'rgba(0,0,0,.75)'
          }"
        >
          <div slot="title" style="font-size: 11px; line-height: 11px">总告警</div>
        </a-statistic>
        <a-divider type="vertical" style="height: 24px"/>
        <a-statistic
          :value="chartData.find(item => item.name === 'unrecovered').value"
          :valueStyle="{
            fontSize: '14px',
            lineHeight: '17px',
            textAlign: 'center',
            color: '#f5222d'
          }"
        >
          <div slot="title" style="font-size: 11px; line-height: 11px">未恢复</div>
        </a-statistic>
      </a-space>
    </div>
    </a-spin>
  </div>
</template>

<script>
import moment from 'moment'
import { getAlertCount } from '@/api/alert'
import SimpleSelect from '@/components/select/SimpleSelect'

export default {
  name: 'ProcessingRate',
  components: {
    SimpleSelect
  },
  data () {
    const rangeOptions = [
      { label: '近 7 日', value: 'week' },
      { label: '近 15 日', value: 'half_month' },
      { label: '近 30 日', value: 'month' }
    ]
    return {
      rangeOptions,
      chartData: [
        { name: 'recovered', value: 0 },
        { name: 'unrecovered', value: 0 }
      ],
      rate: 0,
      total: 0,
      currentRange: 'half_month',
      loading: false
    }
  },
  computed: {
    params () {
      if (this.currentRange === 'week') {
        return {
          datetime_from: moment().subtract(6, 'day').format('YYYY-MM-DD HH:mm'),
          datetime_to: moment().format('YYYY-MM-DD HH:mm'),
          count_of: 'recovered'
        }
      }
      if (this.currentRange === 'month') {
        return {
          datetime_from: moment().subtract(30, 'day').format('YYYY-MM-DD HH:mm'),
          datetime_to: moment().format('YYYY-MM-DD HH:mm'),
          count_of: 'recovered'
        }
      }
      return {
        datetime_from: moment().subtract(14, 'day').format('YYYY-MM-DD HH:mm'),
        datetime_to: moment().format('YYYY-MM-DD HH:mm'),
        count_of: 'recovered'
      }
    }
  },
  created () {
    this.fetch()
  },
  watch: {
    params () {
      this.fetch()
    }
  },
  methods: {
    fetch () {
      this.loading = true
      getAlertCount(this.params).then(res => {
        if (res.data) this.chartData = res.data.data
        else {
          this.chartData = [
            { name: 'recovered', value: 0 },
            { name: 'unrecovered', value: 0 }
          ]
        }
        this.total = this.chartData[0].value + this.chartData[1].value
        const recoveredCount = this.chartData.find(item => item.name === 'recovered').value
        if (recoveredCount) this.rate = (recoveredCount / this.total * 100).toFixed(2) * 1
        else this.rate = 0
      }).finally(() => {
        this.loading = false
      })
    },
    getColor (rate) {
      if (rate >= 80) return '#00b5ff'
      else if (rate >= 60) return '#faad14'
      else return '#ff4d4f'
    }
  }
}
</script>

<style lang="less" scoped>
.processingRate-container {
  position: relative;
  height: 100%;
  padding-top: 20px;

  .rangeContainer {
    position: absolute;
    right: 0px;
    top: -18px;
    z-index: 9999;
  }

  #processing-rate-chart {
    position: relative;
    overflow: hidden;
    :deep(.ant-progress) {
      .ant-progress-inner {
        .ant-progress-circle {
          box-sizing: content-box;
          padding: 10px;
          background: #00a2ff10;
        }
      }
    }
    .circle {
      position: absolute;
      display: block;
      line-height: 128px;
      font-size: 28px;
      font-weight: 500;
      width: 128px;
      height: 128px;
      background: #fff;
      border-radius: 50%;
      top: 50%;
      left: 50%;
      transform: translate(-64px, -64px);
    }
  }
}
</style>
